import { categoryWiseFooterLinkSeoText, ONE_LAKH, ONE_THOUSAND } from './footerInterLinkData';

export const EMPTY_CATEGORY = {
    id: '',
    slug: '',
    name: ''
};

export const DEFAULT_CATEGORY = '-1';

export const CATEGORIES_IDS = {
    RE_PROPERTIES: ['5158', '5160', '4827', '4833', '5154', '5156'],
    CARS: ['84']
};

export const MAIN_CATEGORY = {
    BIKES: '2198',
    BOOKS_SPORTS_HOBBIES: '767',
    CAR: '5',
    CARS: '84',
    ELECTRONICS: '99',
    FASHION: '87',
    FURNITURE: '628',
    JOBS: '4',
    MOBILES: '1411',
    OTHER_VEHICLES: '2207',
    PETS: '103',
    REAL_ESTATE: '3',
    SERVICES: '619',
    COMMERCIAL_VEHICLES_SPARE: '2207',

    // L2 Categories
    HOUSES_FOR_SALE: '1725',
    HOUSES_FOR_RENT: '1723',
    MOBILE_PHONES: '1453',
    ACCESSORIES: '1457',
    TABLETS: '1455',

    LANDS_AND_PLOTS: '1729',
    SHOPS_AND_OFFICES_FOR_RENT: '1731',
    SHOPS_AND_OFFICES_FOR_SALE: '1733',
    PG_AND_GUEST_HOUSES: '1449',

    MOTORCYCLES: '81',
    SCOOTERS: '1413',
    BICYCLES: '1415',

    TV_AND_AUDIO: '1523',
    KITCHEN_OTHER_APPLIANCES: '1417',
    COMPUTER_LAPTOPS: '1505',
    CAMERA_LENSES: '1517',
    GAMES_ENTERTAINMENT: '93',
    FRIDGE: '1617',
    SOFA_DINNING: '1593',
    BEDS_WARDROBES: '1591',
    HOME_DECOR_GARDEN: '575',
    KIDS_FURNITURE: '231',
    OTHER_HOUSEHOLD: '293',
    MEN_FASHION: '1793',
    WOMEN_FASHION: '1795',
    KIDS_FASHION: '235',
    COMMERCIAL_VEHICLES: '85',
    COMMERCIAL_VEHICLES_SPARE_PARTS: '1585',
    BOOKS: '453',
    GYM_FITNESS_EQUIPMENTS: '771',
    MUSICAL_INSTRUMENTS: '714',
    SPORTS_EQUIPMENTS: '100',
    EDUCATION_AND_CLASSES: '1429',
    ELECTRONICS_REPAIR_AND_SERVICES: '523',
    HEALTH_AND_BEAUTY: '741',
    HOME_RENOVATION_AND_REPAIR: '1301',
    CLEANING_AND_PEST_CONTROL: '1302',
    LEGAL_AND_DOCUMENTATION_SERVICES: '1303',
    PACKERS_AND_MOVERS: '1304',
    OTHER_SERVICES: '625',
    FISHES_AND_AQUARIUM: '1293',
    PET_FOOD_AND_ACCESSORIES: '175',
    DOGS: '139',
    OTHER_PETS: '140',
    OTHER_HOBBIES: '755',
    TOURS_AND_TRAVELS: '356',
    ACS: '1619'
};

// The following category Ids does not have FAQ content
export const NO_FAQ_CONTENT_CATEGORY = {
    BOOKS_SPORTS_HOBBIES: '767',
    COMMERCIAL_VEHICLES_SPARE: '2207',

    // L2 Categories
    TOURS_AND_TRAVELS: '356',
    OTHER_HOBBIES: '755',
    OTHER_HOUSEHOLD: '293',
    OTHER_PETS: '140'

};
export const SELL_CATEGORY = {
    MOBILE_PHONES: '1453',
    CARS: '84'
};

export const PRICE_INTERVAL_FOR_CATEGORY = {
    // eslint-disable-next-line no-magic-numbers
    3: ONE_LAKH * 10,
    5: ONE_LAKH,
    87: 500,
    // eslint-disable-next-line no-magic-numbers
    99: ONE_THOUSAND * 5,
    // eslint-disable-next-line no-magic-numbers
    103: ONE_THOUSAND * 5,
    628: 500,
    767: 500,
    // eslint-disable-next-line no-magic-numbers
    1411: ONE_THOUSAND * 5,
    // eslint-disable-next-line no-magic-numbers
    2198: ONE_THOUSAND * 10,
    2207: ONE_LAKH
};

export const getSeoFriendlyCategoryNames = () => {
    const result = {};

    for (const [k, v] of Object.entries(categoryWiseFooterLinkSeoText)) {
        if (v?.categoryName) {
            result[k] = v.categoryName;
        }
    }

    result['1731'] = 'Shops & Offices for Rent';
    result['1733'] = 'Shops & Offices for Sale';
    result['1737'] = 'Data entry & Back office';

    return result;
};

export const categoryToShowAd = categoryId => {
    const categories = ['84'];

    return categories.includes(categoryId);
};
